import { TableAction, TableColumn } from "../types/types";

export const pageSizeDefault = 10;

export const sortDescending = 'desc';

export const htmlCheckIcon = '&#x2714;'

export const emailPattern = "[a-zA-Z0-9_\\-]+(?:[\.]?[a-zA-Z0-9_]+)*@[a-zA-Z0-9\\.\\-]{2,}[\.]{1}[a-zA-Z]{2,}";

export const actionsColumn: TableColumn = {
    name: 'actions',
    description: 'labels.actions',
    mobile: true
}

export const defaultFilterOption = [
    { label: '-- all --', value: '' }
];

export const yesNoFilterOption = [
    { label: '-- all --', value: '' },
    { label: 'Ja', value: 'true' },
    { label: 'Nee', value: 'false'}
];

export const exportAction: TableAction = {
    event: 'export',
    label: 'buttons.export',
    icon: 'download',
    color: 'primary',
    tooltip: 'buttons.export',
    type: 'button'
};

export const importAction: TableAction = {
    event: 'import',
    label: 'buttons.import',
    icon: 'upload',
    color: 'primary',
    tooltip: 'buttons.import',
    type: 'button'
};

export const archiveAction: TableAction = {
    event: 'archive',
    label: 'buttons.archive',
    icon: 'archive',
    color: 'primary',
    tooltip: 'buttons.archive',
    type: 'list'
};

export const unarchiveAction: TableAction = {
    event: 'unarchive',
    label: 'buttons.unarchive',
    icon: 'unarchive',
    color: 'primary',
    tooltip: 'buttons.unarchive',
    type: 'list'
};

export const restoreAction: TableAction = {
    event: 'restore',
    label: 'buttons.restore',
    icon: 'restore_from_trash',
    color: 'primary',
    tooltip: 'buttons.restore',
    type: 'list'
};

export enum DaysOfTheWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6
};